<template>
  <div>
    <div class="details-title">{{ title }}</div>
    <div class="card card-body card-account bg-light">
      <div class="row">
        <div class="col-md-8">
          <p v-if="accountData.opening_hours_from && accountData.opening_hours_till">
            {{ accountData.opening_hours_from }} tot {{ accountData.opening_hours_till }}</p>
          <p v-else>Geen openingstijden opgegeven</p>
        </div>
        <div class="col-md-5 text-right">
          <div @click="$bvModal.show('opening-hours-details-modal')" class="link">Wijzig</div>
        </div>
      </div>
    </div>

    <b-modal ref="opening-hours-details-modal" id="opening-hours-details-modal" footer-class="modal-footer modal-save-details" size="sm" centered>
      <template slot="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
        <button type="button" aria-label="Close" @click="hideModal" class="close">
          <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
        </button>
      </template>
      <template slot="default">
        <div class="col-md-13">
          <form @submit.prevent="onSubmit">
            <div class="form-row">
              <div class="col-md-6">
                <label for="first-name" class="col-form-label">Van</label>
                <input
                  id="first-name"
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': $v.opening_hours_from.$error}"
                  v-model="opening_hours_from"
                  @blur="$v.opening_hours_from.$touch()"
                  placeholder="00:00"
                >
                <span v-if="$v.opening_hours_from.$error" class="invalid-feedback" role="alert">
                  <strong>Vul a.u.b. een openingstijd in.</strong>
                </span>
              </div>
              <div class="col-md-6">
                <label for="first-name" class="col-form-label">Tot</label>
                <input
                  id="last-name"
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': $v.opening_hours_till.$error}"
                  v-model="opening_hours_till"
                  @blur="$v.opening_hours_till.$touch()"
                  placeholder="00:00"
                >
                <span v-if="$v.opening_hours_till.$error" class="invalid-feedback" role="alert">
                  <strong>Vul a.u.b. een sluitingstijd in.</strong>
                </span>
              </div>
            </div>
          </form>
        </div>

        <div
          v-if="openingHoursDetailsStatus"
          class="col-md-13 mt-2 alert"
          role="alert"
          :class="{ 'alert-success': openingHoursDetailsStatus.success, 'alert-danger': !openingHoursDetailsStatus.success }"
        >
          <strong>{{ openingHoursDetailsStatus.message }}</strong>
        </div>
      </template>
      <template slot="modal-footer">
        <button
          @click="saveDetails"
          type="button"
          :disabled="$v.$invalid"
          :class="{'disabled cursor-not-allowed': $v.$invalid}"
          class="btn btn-oldevuuren btn-round w-100">Openingstijden opslaan
          <font-awesome-icon class="font-awesome-icon" v-if="openingHoursDetailsBusy" icon="spinner" spin/>
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { minLength, required } from 'vuelidate/lib/validators'

  import { MUTATE_OPENING_HOURS_DETAILS_STATUS, SAVE_OPENING_HOURS_DETAILS } from '../../../store/types'

  export default {
    props: ['accountData'],
    data() {
      return {
        title: 'Openingstijden (t.b.v. bezorging)',
        opening_hours_from: this.accountData.opening_hours_from,
        opening_hours_till: this.accountData.opening_hours_till
      }
    },
    validations: {
      opening_hours_from: {
        required,
        minLen: minLength(2)
      },
      opening_hours_till: {
        required,
        minLen: minLength(2)
      }
    },
    computed: {
      openingHoursDetailsStatus() {
        return this.$store.getters.openingHoursDetailsStatus
      },
      openingHoursDetailsBusy() {
        return this.$store.getters.openingHoursDetailsBusy
      }
    },
    methods: {
      hideModal() {
        // hide
        this.$refs['opening-hours-details-modal'].hide()
        // discard changes
        this.opening_hours_from = this.accountData.opening_hours_from
        this.opening_hours_till = this.accountData.opening_hours_till
      },
      saveDetails() {
        const formData = {
          opening_hours_from: this.opening_hours_from,
          opening_hours_till: this.opening_hours_till
        }
        this.$store.dispatch(SAVE_OPENING_HOURS_DETAILS, formData).then(() => {
          if (this.openingHoursDetailsStatus.success) {
            this.$refs['opening-hours-details-modal'].hide()
          }
        })
      }
    },
    mounted() {
      const store = this.$store
      this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
        store.commit(MUTATE_OPENING_HOURS_DETAILS_STATUS, null)
      })
    }
  }
</script>

<style lang="scss" scoped>
</style>
